function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "19",
  height: "23",
  viewBox: "0 0 19 23",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18.065 8.463C17.762 5.19 15.83 2.323 12.977.91a8.705 8.705 0 00-8.846.65C1.878 3.126.418 5.659.151 8.463c-.263 2.786.693 5.547 2.604 7.52l5.611 5.845c.2.209.47.326.752.326.282 0 .553-.117.752-.326l5.59-5.846c1.91-1.972 2.867-4.733 2.605-7.52zm-4.087 5.967l-4.87 5.064-4.87-5.064c-1.454-1.511-2.18-3.62-1.98-5.747.2-2.16 1.324-4.112 3.06-5.317a6.633 6.633 0 017.58 0c1.73 1.2 2.852 3.143 3.06 5.295.206 2.135-.52 4.253-1.98 5.769zm-4.87-9.964c-2.632 0-4.765 2.219-4.765 4.955s2.133 4.954 4.764 4.954c2.632 0 4.765-2.218 4.765-4.954-.006-2.734-2.136-4.948-4.765-4.955zm0 7.707c-1.462 0-2.647-1.232-2.647-2.752 0-1.52 1.185-2.753 2.646-2.753 1.462 0 2.647 1.233 2.647 2.753s-1.185 2.752-2.647 2.752z",
  fill: "currentColor",
  fillRule: "evenodd"
})));